import { SubmissionDataCodes } from './getSubmissionDataReferences';

/**
 * Interfaccia per i dati della submission nel contesto di validazione.
 */
export interface IValidationContextSubmissionData {
  /** Booleano "Richiesta in Integrazione" (Sì / No) */
  [SubmissionDataCodes.IsIntegration]: boolean;
  /** Stringa "Fase del Procedimento: ID" */
  [SubmissionDataCodes.PhaseId]: string | null | undefined;
  /** Stringa "Fase del Procedimento: Denominazione" */
  [SubmissionDataCodes.PhaseName]: string | null | undefined;
  /** Stringa "ID Attività" */
  [SubmissionDataCodes.ActivityId]: string | null | undefined;
  /** Stringa "ID Richiesta" */
  [SubmissionDataCodes.RequestId]: string | null | undefined;
}

/**
 * Interfaccia per i parametri di input per costruire i dati della submission.
 */
export interface ISubmissionDataProps {
  phaseId?: string | null;
  phaseName?: string | null;
  originalRequest?: {
    id?: string | null;
    progressivo?: string | null;
  } | null;
  activityId?: string | null;
  requestId?: string | null;
}

/**
 * Costruisce i dati della submission per il contesto di validazione (metadata).
 */
export function getSubmissionValidationContext(
  props: ISubmissionDataProps | null | undefined,
): IValidationContextSubmissionData {
  const isIntegration = Boolean(
    props?.originalRequest?.id && props?.originalRequest?.progressivo,
  );

  return {
    [SubmissionDataCodes.IsIntegration]: isIntegration,
    [SubmissionDataCodes.PhaseId]: props?.phaseId ?? null,
    [SubmissionDataCodes.PhaseName]: props?.phaseName ?? null,
    [SubmissionDataCodes.ActivityId]: props?.activityId ?? null,
    [SubmissionDataCodes.RequestId]: props?.requestId ?? null,
  };
}
